<!-- Buttons -->
<mat-nav-list id="left-nav-buttons">
  <!-- RSF -->
  <!-- Create -->
  <mat-list-item
    (click)="clicked.emit(action.Create)"
    class="parent"
    *ngIf="hasPrivilege(privilegeEnum.RSFCreate)"
  >
    <span class="full-width" *ngIf="isExpanded || isShowing">Create New</span>
    <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
  </mat-list-item>

  <!-- Modify -->
  <mat-list-item
    (click)="clicked.emit(action.Edit)"
    class="parent"
    *ngIf="
      rsf &&
      privileges?.canEdit &&
      !status?.isEditing &&
      !status?.isEditingAmendment
    "
  >
    <span class="full-width" *ngIf="isExpanded || isShowing">Modify Form</span>
    <mat-icon matListItemIcon class="yellow">edit</mat-icon>
  </mat-list-item>

  <!-- Duplicate -->
  <mat-list-item
    (click)="clicked.emit(action.Duplicate)"
    class="parent"
    *ngIf="
      rsf &&
      privileges?.canDuplicate &&
      !status?.isCreating &&
      !status?.isEditing &&
      rsf.status !== formStatusEnum.New
    "
  >
    <span class="full-width" *ngIf="isExpanded || isShowing">Copy Form</span>
    <mat-icon matListItemIcon class="blue">content_copy</mat-icon>
  </mat-list-item>

  <!-- End RSF-->

  <!-- RSF Amendment -->
  <!-- Create Amendment (Full or Minor — dialog will prompt if both privileges exist) -->
  <mat-list-item
    (click)="clicked.emit(action.CreateAmendment)"
    class="parent"
    [disabled]="status?.isCreatingAmendment"
    *ngIf="
      privileges?.canCreateAmendment || privileges?.canCreateMinorAmendment
    "
  >
    <span class="full-width" *ngIf="isExpanded || isShowing"
      >Create Amendment</span
    >
    <mat-icon matListItemIcon class="red">healing</mat-icon>
  </mat-list-item>

  <!-- Modify -->
  <mat-list-item
    (click)="clicked.emit(action.EditAmendment)"
    class="parent"
    *ngIf="
      rsf &&
      privileges?.canEditAmendment &&
      !status?.isEditingAmendment &&
      !status?.isEditing
    "
  >
    <span class="full-width" *ngIf="isExpanded || isShowing"
      >Modify Amendment</span
    >
    <mat-icon matListItemIcon class="yellow">edit</mat-icon>
  </mat-list-item>

  <!-- End RSF Amendment -->

  <!-- Common -->
  <!-- Release -->
  <mat-list-item
    (click)="clicked.emit(action.Release)"
    class="parent"
    *ngIf="canReleaseEditingForm()"
  >
    <span class="full-width" *ngIf="isExpanded || isShowing">Release Form</span>
    <mat-icon matListItemIcon class="red">lock_open</mat-icon>
  </mat-list-item>

  <form-history-button
    #showHistory
    [hidden]="!rsf"
    [isExpanded]="isExpanded"
    [isShowing]="isShowing"
  ></form-history-button>
  <mat-list-item *ngIf="isSA()" (click)="settings()" class="parent line-top">
    <span class="full-width" *ngIf="isExpanded || isShowing">Settings</span>
    <mat-icon matListItemIcon class="gray">settings</mat-icon>
  </mat-list-item>
</mat-nav-list>
